var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.625 31.1777L30.375 51.4277M30.375 31.1777L50.625 51.4277M74.25 41.3027C74.25 59.9423 59.1396 75.0527 40.5 75.0527C21.8604 75.0527 6.75 59.9423 6.75 41.3027C6.75 22.6631 21.8604 7.55273 40.5 7.55273C59.1396 7.55273 74.25 22.6631 74.25 41.3027Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.c75f3007b68926bf0583b7472a787f86.svg";
export { ForwardRef as ReactComponent };